const randomInt = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min

/* 
    See "The Fisher-Yates Shuffle : The Modern Method" 
    Link : https://en.wikipedia.org/wiki/Fisher%E2%80%93Yates_shuffle 

    Generates a "random" permutation of an array.
*/
export const fisherYatesShuffle = xs => {
  var newXs = []
  var lastIndex = xs.length - 1

  while (newXs.length < xs.length) {
    const randomIndex = randomInt(0, lastIndex)
    const oldLastElem = xs[lastIndex]

    /* The new last element is the element that was selected randomly */
    xs[lastIndex] = xs[randomIndex]

    xs[randomIndex] = oldLastElem
    /* 
        The next element pushed into the new array is the randomly selected one,
        which is now the "last" of the old array
      */
    newXs.push(xs[lastIndex])

    lastIndex = lastIndex - 1
  }

  return newXs
}
